module.exports = __webpack_public_path__ + "img/engela.81a8ac2b.jpg";